import React from 'react'
import { string } from 'prop-types'

export const PulseBarPreloader = ({ width, height, fill }) => (
	<svg
		width={width || '80px'}
		height={height || '80px'}
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 100 100"
		preserveAspectRatio="xMidYMid"
		className="lds-facebook"
	>
		<rect x="17.5" y="30" width="15" height="40" fill={fill || '#ef7c00'}>
			<animate
				attributeName="y"
				calcMode="spline"
				values="18;30;30"
				keyTimes="0;0.5;1"
				dur="1"
				keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
				begin="-0.2s"
				repeatCount="indefinite"
			></animate>
			<animate
				attributeName="height"
				calcMode="spline"
				values="64;40;40"
				keyTimes="0;0.5;1"
				dur="1"
				keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
				begin="-0.2s"
				repeatCount="indefinite"
			></animate>
		</rect>
		<rect x="42.5" y="29.9934" width="15" height="40.0132" fill={fill || '#ef7c00'}>
			<animate
				attributeName="y"
				calcMode="spline"
				values="20.999999999999996;30;30"
				keyTimes="0;0.5;1"
				dur="1"
				keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
				begin="-0.1s"
				repeatCount="indefinite"
			></animate>
			<animate
				attributeName="height"
				calcMode="spline"
				values="58.00000000000001;40;40"
				keyTimes="0;0.5;1"
				dur="1"
				keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
				begin="-0.1s"
				repeatCount="indefinite"
			></animate>
		</rect>
		<rect x="67.5" y="29.7935" width="15" height="40.413" fill={fill || '#ef7c00'}>
			<animate
				attributeName="y"
				calcMode="spline"
				values="24;30;30"
				keyTimes="0;0.5;1"
				dur="1"
				keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
				begin="0s"
				repeatCount="indefinite"
			></animate>
			<animate
				attributeName="height"
				calcMode="spline"
				values="52;40;40"
				keyTimes="0;0.5;1"
				dur="1"
				keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
				begin="0s"
				repeatCount="indefinite"
			></animate>
		</rect>
	</svg>
)

PulseBarPreloader.propTypes = {
	fill: string,
	height: string,
	width: string,
}
